import React, { Component } from 'react';
import _ from 'lodash';

import ParkingConnlocationsTable from '../components/ParkingConnlocationsTable';
import ParkingConnlocationsForm from '../components/ParkingConnlocationsForm';

import ParkingConnlocationsModel from '../components/ParkingConnlocationsModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, message } from 'antd';

class ParkingConnlocationsScreen extends Component {

    state = {
        dataLoading: true,
        dataAll: [],
        data: [],
        parkinglocationFormModalVisible: false,
        parkinglocationFormDefaultValues: null,
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        this.setState({
            dataLoading: true
        });
        ParkingConnlocationsModel.getAll()
            .then(data => {
                this.setState({
                    dataLoading: false,
                    dataAll: data,
                    data: data
                });
            });
    }

    onSearch(searchText) {
        const dataAll = this.state.dataAll;
        this.setState({
            data: _.filter(dataAll, (d) => { return d['name'].toLowerCase().includes(searchText.toLowerCase()); })
        })
    }

    render() {
        return (
            <Layout.Content style={{ margin: '24px 16px 0' }}>
                <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
                    <h2>Parkovací systémy - Seznam lokalit</h2>
                    <div style={{ marginBottom: '20px' }}>
                        <Row>
                            <Col span={8}>
                                <Input.Search
                                    placeholder="Název lokality"
                                    onSearch={this.onSearch.bind(this)}
                                    style={{ width: 300 }} />
                            </Col>
                            <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                                <Button type="default" onClick={() => { this.loadData(true) }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
                                {UserModel.isInRoles(['ADMIN', 'PARKINGCONN_PARKINGLOCATIONS_WRITE'])
                                    ? <Button type="default" onClick={() => { this.setState({ parkinglocationFormModalVisible: true }) }}>Nová lokalita</Button>
                                    : null}
                            </Col>
                        </Row>
                    </div>
                    <ParkingConnlocationsForm
                        type="modal"
                        modalVisible={this.state.parkinglocationFormModalVisible}
                        defaultValues={this.state.parkinglocationFormDefaultValues}
                        onModalCancel={(form) => {
                            form.resetFields();
                            this.setState({
                                parkinglocationFormModalVisible: false,
                                parkinglocationFormDefaultValues: null
                            });
                        }}
                        onSuccess={(form, values) => {
                            ParkingConnlocationsModel.create(values)
                                .then(() => {
                                    message.success('Lokalita byla vložena!');
                                    form.resetFields();
                                    this.setState({
                                        parkinglocationFormModalVisible: false,
                                        parkinglocationFormDefaultValues: null
                                    });
                                    this.loadData(true);
                                });
                        }} />
                    <ParkingConnlocationsTable
                        data={this.state.data}
                        loading={this.state.dataLoading}
                        onDetailRow={(record) => {
                            this.setState({
                                parkinglocationFormModalVisible: true,
                                parkinglocationFormDefaultValues: record
                            });
                        }}
                        onRemoveRow={(id) => {
                            ParkingConnlocationsModel.remove(id)
                                .then(() => {
                                    message.success('Lokalita byla smazána!');
                                    this.loadData();
                                });
                        }}
                        onAnyFormSuccess={() => {
                            this.loadData();
                        }} />
                </div>
            </Layout.Content>
        );
    }
}

export default ParkingConnlocationsScreen;



// WEBPACK FOOTER //
// ./src/screens/ParkingConnlocationsScreen.js